'use client'
import { Container } from '@/src/ct-design/lib'
import { Brand } from '@/src/utils/brand'
import { getNavbarProperties } from '@/src/utils/navbar'
import { isMobileApp } from '@/src/utils/helper'
import { useEffect, useState } from 'react'

const Navbar = ({ brand }: { brand: Brand }) => {
    const [isVisible, setIsVisible] = useState(true)
    const { brandLogo: BrandLogo } = getNavbarProperties(brand)

    useEffect(() => {
        setIsVisible(!isMobileApp())
    }, [])

    if (!isVisible) return null

    return (
        <Container className='flex p-relative'>
            <Container
                className={`flex z-10 flex-middle pl-2 pr-1 py-4`}
                height='40px'
                onClick={() => {
                    window.location.href = '/my-account'
                }}
            ></Container>
            <Container className='p-absolute l-0 r-0 t-0 b-0 flex flex-center flex-middle'>
                <BrandLogo />
            </Container>
        </Container>
    )
}

export default Navbar
